import { omit } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

import ButtonTooltip from '../../components/button-tooltip';
import withFontClassName from '../../hoc/with-font-class-name';
import styles from './button.scss';

const SHOW_TIMEOUT = 200;
const HIDE_TIMEOUT = 3000;

class Button extends Component {
  state = {
    isTooltipVisible: false,
  };

  componentWillUnmount() {
    this.hideTooltip();
  }

  showTooltip() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.setState({ isTooltipVisible: true }, () => {
        this.timeout = setTimeout(() => this.hideTooltip(), HIDE_TIMEOUT);
      });
    }, SHOW_TIMEOUT);
  }

  hideTooltip() {
    clearTimeout(this.timeout);
    this.setState({
      isTooltipVisible: false,
    });
  }

  handleMouseEnter = () => {
    this.showTooltip();
  };

  handleMouseLeave = () => {
    this.hideTooltip();
  };

  renderTooltip() {
    const { isTooltipVisible } = this.state;
    const { tooltipText } = this.props;

    if (!tooltipText) {
      return null;
    }

    return (
      <ButtonTooltip isVisible={isTooltipVisible} target={this}>
        {tooltipText}
      </ButtonTooltip>
    );
  }

  render() {
    const {
      component: Component,
      className,
      contentFontClassName,
      isSecondary,
      isMuted,
      children,
      ...otherProps
    } = this.props;
    const isPrimary = !isSecondary;
    const containerClassName = classNames(
      styles.button,
      className,
      contentFontClassName,
      isPrimary ? 'button-background-color' : 'button-border-color',
      isPrimary ? 'button-primary-text-color' : 'button-secondary-text-color',
      {
        [styles.secondary]: isSecondary,
        [styles.isMuted]: isMuted,
      }
    );
    const componentProps = omit(
      otherProps,
      'currentUser',
      'dispatch',
      'isAuthenticated',
      'isBlocked',
      'isDemoMode',
      'isOwner',
      'openModal',
      'titleFontClassName',
      'tooltipText',
      'viewMode',
      'forPublicUser',
      'isPrivate',
    );

    return (
      <Component
        className={containerClassName}
        {...componentProps}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {this.renderTooltip()}
        <span className={styles.wrapper}>
          {children}
        </span>
      </Component>
    );
  }
}

Button.propTypes = {
  contentFontClassName: PropTypes.string.isRequired,
  type: PropTypes.string,
  className: PropTypes.string,
  isSecondary: PropTypes.bool,
  isMuted: PropTypes.bool,
  component: PropTypes.any,
  children: PropTypes.node,
  tooltipText: PropTypes.string,
};

Button.defaultProps = {
  component: 'button',
};

export default withFontClassName(Button);



// WEBPACK FOOTER //
// ./app/components/button/button.js